import { isDocument, StructuredText } from 'datocms-structured-text-utils';

// Based on Dato type guard but with an added check for for whether the field is an object
// Sometimes we use string/structured text fields in the same location
// Reference: https://github.com/datocms/structured-text/blob/main/packages/utils/src/guards.ts#L101

export const isStructuredText = (field: string | null | undefined | StructuredText): field is StructuredText => {
  return !!field && typeof field === 'object' && 'value' in field && isDocument(field.value);
};
